// core version + navigation module:
import Swiper, { Navigation } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation]);


$(function () {
    // global var for large screen media query
    let mq = window.matchMedia("(min-width: 1024px)");
    // global var for medium screen media query
    let mqMed = window.matchMedia("(min-width: 576px)");

    // event sliders
    let mySwiper = new Swiper('.js-eventSlider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        disableOnInteraction: false,

        // Navigation arrows
        navigation: {
            nextEl: '.eventSlider__button.-next',
            prevEl: '.eventSlider__button.-prev',
        },
        breakpoints: {
            // when window width is >= 576px (matches md value)
            576: {
                slidesPerView: 1.33,
            },
        }
    })

    if (mqMed.matches) {
        // position the nav elements
        let slideWidth = $('.eventSlider__slide').outerWidth();
        let $nav = $('.eventSlider__nav');
        $nav.css('left', slideWidth);

        // making sure it stays positioned correctly on resize on larger windows
        $(window).on('resize', function () {
            let slideWidth = $('.eventSlider__slide').outerWidth();
            let $nav = $('.eventSlider__nav');
            $nav.css('left', slideWidth);
        });
    }

});